//src/api/interceptors/authInterceptors.ts
import type { FetchOptions } from '@/types/api.types';
import { clearSessionToken, getSessionToken } from '@/utils/sessionStorage';

export const authRequestInterceptor = (options: FetchOptions): FetchOptions => {
  const token = getSessionToken();
  const headers = { ...(options.headers ?? {}) };
   if ((token !== null) && token.trim() !== '') {
    headers.Authorization = `Bearer ${token}`;
  }
  const mergedOptions: FetchOptions = {
    ...options,
    headers
  };
  return mergedOptions;
};

const HTTP_STATUS_UNAUTHORIZED = 401;

export const authResponseInterceptor = (response: Response): Response => {
  if (response.status === HTTP_STATUS_UNAUTHORIZED) {
    const path = window.location.pathname.toLowerCase();
    const AUTH_PATH_PREFIXES = ['/login', '/registration'];

    const onAuthScreen = AUTH_PATH_PREFIXES.some(
      (p) => path === p || path.startsWith(`${p}/`)
    );
    clearSessionToken();
    if (!onAuthScreen) {
      window.location.replace('/login');
    }
  }
  return response;
};
